module.exports = __webpack_public_path__ + "static/img/iconfont.4d8d001.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg
// module id = /Ofu
// module chunks = 35